import { Row, Col, Breadcrumb } from "react-bootstrap";
import EpaCard from "../../leap-components/EpaCard";

const HomeText = () => {
  const text = (
    <div>
      <p style={{ fontWeight: "bold" }}>
        Welcome to LEAP, the EPA's Licence and Enforcement Access Portal
      </p>
      <p>
        LEAP provides access to application documentation and formal compliance
        and enforcement correspondence exchanged¹ between the EPA, applicants,
        and regulated operators across the following activity areas:
      </p>
      <ul style={{ listStyleType: "square" }}>
        <li>Circular Economy Regulation (By-Product and End-of-Waste)</li>
        <li>Certificates of Registration (issued to Local Authorities)</li>
        <li>Dumping at Sea</li>
        <li>Greenhouse Gas Permits (GHG)</li>
        <li>Historic Landfills</li>
        <li>
          Industrial Activities: Industrial Emissions (IE), Integrated Pollution
          Prevention & Control (IPPC), Integrated Pollution Control (IPC)
        </li>
        <li>Medium Combustion Plant Registrations</li>
        <li>Radiological Protection</li>
        <li>
          Urban Waste Water Discharge: Waste Water Discharge Authorisations
          (WWDA) and Certificates of Authorisation (CoA)
        </li>
        <li>Volatile Organic Compounds (VOC)</li>
        <li>Waste Management</li>
        <li>Water Abstractions</li>
      </ul>
      <p>
        LEAP allows you to view details of applications, licences, and permits
        issued by the EPA. It also includes records related to the regulation of
        licensed and permitted sites, such as EPA site inspection and monitoring
        reports, licensee returns, incidents, non-compliances, complaints, and
        compliance investigations¹.
      </p>
      <p>
        <a
          style={{ fontWeight: "bold" }}
          href="https://www.epa.ie/our-services/compliance--enforcement/whats-happening/leap-online?_gl=1%2al299vs%2a_ga%2aODAyODg1MjY5LjE3NTA3NTUwMTA.%2a_ga_TPK2CK9KEX%2aczE3NTA3NTUwMTAkbzEkZzAkdDE3NTA3NTUwMTAkajYwJGwwJGgw"
        >
          Find more about LEAP
        </a>
      </p>
      <small>
        <p>
          ¹
          <a
            target="_blank"
            href="https://www.epa.ie/publications/compliance--enforcement/licensees/performance/epa-guidance-note-on-leap-online-public-access-portal-v20-may-2023.php"
          >
            special rules
          </a>{" "}
          apply to Greenhouse Gas Permitting whereby only the permit is
          accessible
        </p>
      </small>
      <p></p>
      <p style={{ fontWeight: "bold" }}>Available Registers</p>
      <p>
        The following registers provide more detailed information for specific
        regulatory regimes:
      </p>
      <ul style={{ listStyleType: "square" }}>
        <li>
          <a target="_blank" href="https://circulareconomy.epa.ie/">
            Circular Economy Register - By-Product
          </a>
        </li>
        <li>
          <a target="_blank" href="https://circulareconomy.epa.ie/endofwaste">
            Circular Economy Register – End-of-Waste
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="https://www.epa.ie/our-services/licensing/climate-change/eu-emissions-trading-system-/emissions-trading-system---stationary-installations/access-to-current-permits-/"
          >
            Greenhouse Gas Permit Register
          </a>
        </li>
        <li>
          <a target="_blank" href="https://www.epa.ie/mcp">
            Medium Combustion Plant Register
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="https://circulareconomy.epa.ie/certificatesofregistration"
          >
            Waste Certificates of Registration Register
          </a>
        </li>
        <li>
          <a target="_blank" href="https://leap.epa.ie/abstractions/">
            Water Abstractions Register
          </a>
        </li>
      </ul>
    </div>
  );

  return (
    <Row>
      <Col className="col-12">{text}</Col>
    </Row>
  );
};

export default HomeText;
